import Checkbox, { CheckboxProps } from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import { FieldProps } from "formik";
import React from "react";

interface Props extends CheckboxProps {
  label: string;
}

const CheckboxFormFieldFormik: React.FC<FieldProps & Props> = React.memo(
  ({ form, field, label, ...props }) => (
    <FormControlLabel
      control={
        <Checkbox
          {...props}
          checked={!!field.value}
          onChange={(e) => form.setFieldValue(field.name, e.target.checked)}
        />
      }
      label={label}
    />
  ),
)

export default CheckboxFormFieldFormik
